import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    lineHeight: 'initial',
    '&.MuiInputLabel-shrink': {
      transform: 'none !important',
    },
  },
  asterisk: {
    color: '#ef5350',
  },
}));